(function () {
  const CFG = {
    bottles: {
      default: 3, min: 1, max: 20, step: 1,
      unit:      'bottles per day',
      annualFn:  n => Math.round(n * 365),
      costFn:    n => Math.round(n * 365 * 0.80),
      litersFn:  n => n * 365 * 0.5,
      annualStr: n => '= ' + fmt(n * 365) + ' / year',
      bottleLbl: () => 'Bottles per year',
      capsLbl:   () => 'Caps discarded',
      capsVal:   n => fmt(Math.round(n * 365)),
      microFn:   n => Math.round(n * 365 * 10000),
      summaryFn: (annual, micro) =>
        `Your <strong>${fmt(annual)} bottles</strong> will each take roughly ` +
        `<em class="ww-hi">450 years</em> to break down — ` +
        `<em class="ww-hi">18 generations</em> from now. ` +
        `In total, they'll release <em class="ww-hi">${fmtN(micro)} microplastic fragments</em> into the environment.`,
    },
    jugs: {
      default: 3, min: 0.5, max: 8, step: 0.5,
      unit:      'jugs per week',
      annualFn:  n => Math.round(n * 52),
      costFn:    n => Math.round(n * 52 * 8.50),
      litersFn:  n => n * 52 * 18.9,
      annualStr: n => '= ' + fmt(n * 52) + ' / year',
      bottleLbl: () => 'Jugs per year',
      capsLbl:   () => 'Caps discarded',
      capsVal:   n => fmt(Math.round(n * 52)),
      microFn:   n => Math.round(n * 52 * 10000 + (n * 52 / 50) * 10000),
      summaryFn: (annual, micro) =>
        `Your <strong>${fmt(annual)} jug caps</strong> will each persist for over ` +
        `<em class="ww-hi">400 years</em> — roughly <em class="ww-hi">16 generations</em>. ` +
        `Combined with the jugs, they'll shed ` +
        `<em class="ww-hi">${fmtN(micro)} microplastic fragments</em> over their lifetime.`,
    },
  };
  const WW = 708;
  let wwType = 'bottles', wwValue = 3, wwHolding = false, wwFirst = true;
  function fmt(n)  { return Math.round(n).toLocaleString(); }
  function fmtV(v) { return v % 1 === 0 ? String(v) : v.toFixed(1); }
  function fmtN(n) {
    if (n >= 1e9) return (n / 1e9).toFixed(1) + 'B';
    if (n >= 1e6) return (n / 1e6 < 10 ? (n / 1e6).toFixed(1) : Math.round(n / 1e6)) + 'M';
    if (n >= 1e3) return Math.round(n / 1000) + 'K';
    return Math.round(n).toLocaleString();
  }
  function rollCounter(el, newText, dir) {
    el.style.animation = 'none';
    void el.offsetWidth;
    el.textContent = newText;
    el.style.animation = (dir > 0 ? 'ww-count-up' : 'ww-count-down') + ' 240ms cubic-bezier(0.16,1,0.3,1) both';
  }
  function flashValues() {
    document.querySelectorAll('#calculator .ww-ryou, #calculator .ww-rcell--hero-you').forEach(el => {
      el.classList.remove('ww-flash'); void el.offsetWidth; el.classList.add('ww-flash');
    });
  }
  function warmColor(t) {
    const r = Math.round(17 + (192 - 17) * t);
    const g = Math.round(17 + (85  - 17) * t);
    const b = Math.round(17 + (0   - 17) * t);
    return `rgb(${r},${g},${b})`;
  }
  function fadeSummary(updateFn) {
    const txt = document.getElementById('ww-summary');
    txt.classList.add('is-fading');
    setTimeout(() => { updateFn(); txt.classList.remove('is-fading'); }, 190);
  }
  function wwRender(skipAnim, counterDir) {
    skipAnim   = !!skipAnim;
    counterDir = counterDir || 0;
    const c       = CFG[wwType];
    const annual  = c.annualFn(wwValue);
    const cost    = c.costFn(wwValue);
    const nano    = c.litersFn(wwValue) * 240000;
    const micro   = c.microFn(wwValue);
    const savings = cost - WW;
    const animate = !skipAnim && !wwHolding && !wwFirst;
    if (animate) flashValues();
    const numEl = document.getElementById('ww-num');
    if (animate && counterDir !== 0) { rollCounter(numEl, fmtV(wwValue), counterDir); }
    else { numEl.textContent = fmtV(wwValue); }
    document.getElementById('ww-unit').textContent = c.unit;
    document.getElementById('ww-yr').textContent   = c.annualStr(wwValue);
    document.getElementById('ww-dec').disabled     = wwValue <= c.min;
    document.getElementById('ww-inc').disabled     = wwValue >= c.max;
    document.getElementById('ww-cost').textContent       = '$' + fmt(cost);
    document.getElementById('ww-bottles').textContent    = fmt(annual);
    document.getElementById('ww-bottle-lbl').textContent = c.bottleLbl();
    document.getElementById('ww-caps').textContent       = c.capsVal(wwValue);
    document.getElementById('ww-caps-lbl').textContent   = c.capsLbl();
    document.getElementById('ww-nano').textContent       = fmtN(nano);
    document.getElementById('ww-micro').textContent      = fmtN(micro);
    const t = Math.max(0, Math.min(1, (wwValue - c.min) / (c.max - c.min)));
    document.getElementById('ww-cost').style.color = warmColor(t);
    const html = c.summaryFn(annual, micro);
    if (animate) { fadeSummary(() => { document.getElementById('ww-summary').innerHTML = html; }); }
    else { document.getElementById('ww-summary').innerHTML = html; }
    const stxt = document.getElementById('ww-stxt');
    if (savings > 0) { stxt.textContent = 'Save $' + fmt(savings) + ' / year switching to Wisewell'; stxt.classList.remove('is-negative'); }
    else { stxt.textContent = '$' + fmt(WW - cost) + ' more / yr — zero plastic, zero nanoplastics'; stxt.classList.add('is-negative'); }
    wwFirst = false;
  }
  function wwStep(delta) {
    const c = CFG[wwType];
    const prev = wwValue;
    wwValue = Math.min(c.max, Math.max(c.min, Math.round((wwValue + delta * c.step) * 10) / 10));
    if (wwValue !== prev) wwRender(false, delta > 0 ? 1 : -1);
  }
  document.getElementById('ww-dec').addEventListener('click', () => wwStep(-1));
  document.getElementById('ww-inc').addEventListener('click', () => wwStep(+1));
  ['ww-dec', 'ww-inc'].forEach(id => {
    const b = document.getElementById(id);
    const doSpring = () => { b.classList.remove('ww-spring'); void b.offsetWidth; b.classList.add('ww-spring'); };
    b.addEventListener('mousedown',  doSpring);
    b.addEventListener('touchstart', doSpring, { passive: true });
    b.addEventListener('animationend', () => b.classList.remove('ww-spring'));
  });
  let wwHoldTimer, wwRepeatTimer;
  function wwStartHold(d) {
    wwHoldTimer = setTimeout(() => {
      wwHolding = true;
      wwRepeatTimer = setInterval(() => wwStep(d), 90);
    }, 360);
  }
  function wwStopHold() { clearTimeout(wwHoldTimer); clearInterval(wwRepeatTimer); wwHolding = false; }
  [['ww-dec', -1], ['ww-inc', 1]].forEach(([id, d]) => {
    const b = document.getElementById(id);
    b.addEventListener('mousedown',  () => wwStartHold(d));
    b.addEventListener('touchstart', () => wwStartHold(d), { passive: true });
    ['mouseup', 'mouseleave', 'touchend'].forEach(e => b.addEventListener(e, wwStopHold));
  });
  const wwToggleEl = document.querySelector('#calculator .ww-toggle');
  document.querySelectorAll('#calculator .ww-tbtn').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.dataset.type === wwType) return;
      const prev = wwValue;
      wwType  = btn.dataset.type;
      wwValue = CFG[wwType].default;
      const dir = wwValue > prev ? 1 : -1;
      document.querySelectorAll('#calculator .ww-tbtn').forEach(b => {
        b.classList.toggle('is-active', b === btn);
        b.setAttribute('aria-pressed', String(b === btn));
      });
      wwToggleEl.dataset.active = wwType;
      wwRender(false, dir);
    });
  });
  wwRender(true);
}());